import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--bg-quaternary);
  background-color: var(--bg-primary);
`
